import React from "react";
import HeroSection from "./HeroSection";
import PricingGrid from "./PricingGrid";

function Charges() {
  return (
    <>
      <HeroSection />
      <PricingGrid />
    </>
  );
}

export default Charges;
